import {StyleParamType, wixColorParam, wixFontParam, createStylesParams} from '@wix/tpa-settings'

export type CommonButtonStylesParams = {
  buttonDefaultCornerRadiusTopLeft: StyleParamType.Number
  buttonDefaultCornerRadiusTopRight: StyleParamType.Number
  buttonDefaultCornerRadiusBottomLeft: StyleParamType.Number
  buttonDefaultCornerRadiusBottomRight: StyleParamType.Number
}

export type HeaderButtonStylesParams = {
  headerButtonDefaultFont: StyleParamType.Font
  headerButtonDefaultColor: StyleParamType.Color
  headerButtonDefaultFillColor: StyleParamType.Color
  headerButtonDefaultBorderWidth: StyleParamType.Number
  headerButtonDefaultBorderColor: StyleParamType.Color

  headerButtonHoverFont: StyleParamType.Font
  headerButtonHoverColor: StyleParamType.Color
  headerButtonHoverFillColor: StyleParamType.Color
  headerButtonHoverBorderColor: StyleParamType.Color
}

export type FormButtonStylesParams = {
  formButtonDefaultFont: StyleParamType.Font
  formButtonDefaultColor: StyleParamType.Color
  formButtonDefaultFillColor: StyleParamType.Color
  formButtonDefaultBorderWidth: StyleParamType.Number
  formButtonDefaultBorderColor: StyleParamType.Color

  formButtonHoverFont: StyleParamType.Font
  formButtonHoverColor: StyleParamType.Color
  formButtonHoverFillColor: StyleParamType.Color
  formButtonHoverBorderColor: StyleParamType.Color
}

export const commonButtonStylesParams = createStylesParams<CommonButtonStylesParams>({
  buttonDefaultCornerRadiusTopLeft: {
    type: StyleParamType.Number,
    getDefaultValue: () => 0,
  },
  buttonDefaultCornerRadiusTopRight: {
    type: StyleParamType.Number,
    getDefaultValue: () => 0,
  },
  buttonDefaultCornerRadiusBottomLeft: {
    type: StyleParamType.Number,
    getDefaultValue: () => 0,
  },
  buttonDefaultCornerRadiusBottomRight: {
    type: StyleParamType.Number,
    getDefaultValue: () => 0,
  },
})

export const headerButtonStylesParams = createStylesParams<HeaderButtonStylesParams>({
  headerButtonDefaultFont: {
    type: StyleParamType.Font,
    getDefaultValue: wixFontParam('Body-M', {size: 16}),
  },
  headerButtonDefaultColor: {
    type: StyleParamType.Color,
    getDefaultValue: wixColorParam('color-1'),
  },
  headerButtonDefaultFillColor: {
    type: StyleParamType.Color,
    getDefaultValue: wixColorParam('color-8', 1),
  },
  headerButtonDefaultBorderWidth: {
    type: StyleParamType.Number,
    getDefaultValue: () => 0,
  },
  headerButtonDefaultBorderColor: {
    type: StyleParamType.Color,
    getDefaultValue: wixColorParam('color-line', 0.12),
  },

  headerButtonHoverFont: {
    type: StyleParamType.Font,
    getDefaultValue: wixFontParam('Body-M', {
      size: 16,
      style: {bold: false, italic: false, underline: true},
    }),
  },
  headerButtonHoverColor: {
    type: StyleParamType.Color,
    getDefaultValue: wixColorParam('color-1'),
  },
  headerButtonHoverFillColor: {
    type: StyleParamType.Color,
    getDefaultValue: wixColorParam('color-action', 1),
  },
  headerButtonHoverBorderColor: {
    type: StyleParamType.Color,
    getDefaultValue: wixColorParam('color-line', 0.12),
  },
})

export const formButtonStylesParams = createStylesParams<FormButtonStylesParams>({
  formButtonDefaultFont: {
    type: StyleParamType.Font,
    getDefaultValue: wixFontParam('Body-M', {size: 16}),
  },
  formButtonDefaultColor: {
    type: StyleParamType.Color,
    getDefaultValue: wixColorParam('color-1'),
  },
  formButtonDefaultFillColor: {
    type: StyleParamType.Color,
    getDefaultValue: wixColorParam('color-8', 1),
  },
  formButtonDefaultBorderWidth: {
    type: StyleParamType.Number,
    getDefaultValue: () => 0,
  },
  formButtonDefaultBorderColor: {
    type: StyleParamType.Color,
    getDefaultValue: wixColorParam('color-line', 0.12),
  },

  formButtonHoverFont: {
    type: StyleParamType.Font,
    getDefaultValue: wixFontParam('Body-M', {
      size: 16,
      style: {bold: false, italic: false, underline: true},
    }),
  },
  formButtonHoverColor: {
    type: StyleParamType.Color,
    getDefaultValue: wixColorParam('color-1'),
  },
  formButtonHoverFillColor: {
    type: StyleParamType.Color,
    getDefaultValue: wixColorParam('color-action', 1),
  },
  formButtonHoverBorderColor: {
    type: StyleParamType.Color,
    getDefaultValue: wixColorParam('color-line', 0.12),
  },
})
